import { type History } from '@direct-frontend/modules-router';
import { pathToPageName } from '../dom';

// Вызывать до монтирования React-роутера, чтобы page обновлялся перед рендером нового маршрута.
export function subscribeToErrorBoosterPageChanges(history: History): () => void {
    let previousPathname = history.location.pathname;

    return history.listen(({ location }) => {
        if (location.pathname === previousPathname) {
            return;
        }

        previousPathname = location.pathname;
        window.Ya?.Rum?.updateErrors?.({ page: pathToPageName(location.pathname) });
    });
}
